import React from "react";
import styles from "./Navbar.module.css";

const Navbar = () => {
  const handleNavigate = (path) => {
    window.location.href = path;
  };

  return (
    <nav className={styles.sidebar}>
      <div className={styles.logo}>BodyFriend</div>
      <ul className={styles.navList}>
        <li onClick={() => handleNavigate("/bodyfriend-cms")}>Dashboard</li>
        <li onClick={() => handleNavigate("/bodyfriend-cms/manage-product")}>
          Products
        </li>
        <li onClick={() => handleNavigate("/bodyfriend-cms/manage-event")}>
          Events
        </li>
        <li onClick={() => handleNavigate("/bodyfriend-cms/manage-faq")}>
          FAQ
        </li>
        <li onClick={() => handleNavigate("/bodyfriend-cms/manage-review")}>
          Reviews
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
